import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { FormStateService, UserIdleService } from '@ld.consumer-portal/utils';
import { CanComponentDeactivate } from './can-deactivate.interface';

export const contactInfoGuard: CanDeactivateFn<unknown> = (component) => {
  const formStateService = inject(FormStateService);
  const userIdleService = inject(UserIdleService);

  if (userIdleService.isIdleLogout) {
    return true;
  }

  const hasUnsavedEdits = formStateService.hasContactInfoChanges();
  const hasConfirmPending = formStateService.hasContactInfoConfirmPending();

  if (!hasUnsavedEdits && !hasConfirmPending) {
    return true;
  }

  if (component && typeof (component as CanComponentDeactivate).canDeactivate === 'function') {
    return (component as CanComponentDeactivate).canDeactivate();
  }

  if (hasUnsavedEdits) {
    return window.confirm(
      'You have unsaved changes to your contact information. Are you sure you want to leave this page? Your changes will be lost.'
    );
  }

  if (hasConfirmPending) {
    return window.confirm('You have not confirmed your contact information. Are you sure you want to leave this page?');
  }

  return true;
};
